module.exports = __webpack_public_path__ + "static/img/offer-bg.15be255.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sass/images/bg/offer-bg.jpg
// module id = xNht
// module chunks = 1